module.exports = __webpack_public_path__ + "img/inge-v9-3.baff62df.png";